export const DATE_TIME_FORMAT = 'MM/dd/yyyy HH:mm';
export const DISCORD_URL = 'https://discord.gg/u8SmfwPpMd';
export const QUICK_START_URL = 'https://dstack.ai/docs/quickstart/';
export const TALLY_FORM_ID = '3xYlYG';
export const DOCS_URL = 'https://dstack.ai/docs/';
export const DEFAULT_TABLE_PAGE_SIZE = 20;
